import {billingAppName} from "../data/platform-data";

export enum BvtFeatureFlags {
    SCMT10914BPAYtextupdate = "SCMT10914BPAYtextupdate",
    TEDIG7717SingleInvoiceView = "TEDIG7717SingleInvoiceView"
}

export interface IFeatureFlagWithBVT {
    bvtEnabledFeature: boolean;
    flagState: boolean;
}

export type FlagApplicationNames =
| typeof billingAppName;


export interface IUseBvtFlagsCheckerProps {
    bvtFlagName: BvtFeatureFlags;
    cidn?: string;
    appName?: FlagApplicationNames;
}
